const state = {
  showPlayList: false,
};

const mutations = {
  SET_SHOW_PLAYLIST: (state, show) => {
    state.showPlayList = show;
  },
};

const actions = {
  setShowPlayList({ commit }, show) {
    commit('SET_SHOW_PLAYLIST', show);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}; 